import { Box, Container, Paper, Link, Stack } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import etBusinessLogo from '../../assets/etbusiness-logo.svg';

interface StaticPageLayoutProps {
  children: React.ReactNode;
}

export default function StaticPageLayout({ children }: StaticPageLayoutProps) {
  return (
    <Box sx={{ width: '100%', minHeight: '100vh', bgcolor: '#F8FAFC' }}>
      <Paper 
        elevation={0} 
        sx={{ 
          borderBottom: '1px solid',
          borderColor: 'divider',
          position: 'sticky',
          top: 0,
          zIndex: 1100,
          bgcolor: 'white',
          backdropFilter: 'blur(8px)',
          boxShadow: '0 4px 30px rgba(0, 0, 0, 0.03)',
        }}
      >
        <Container maxWidth="lg">
          <Box sx={{ 
            py: 2.5,
            display: 'flex', 
            alignItems: 'center',
            justifyContent: 'space-between'
          }}>
            <Link component={RouterLink} to="/">
              <Box
                component="img"
                src={etBusinessLogo}
                alt="ET-Business Logo"
                sx={{ 
                  height: '40px',
                  width: 'auto',
                  cursor: 'pointer',
                  '&:hover': {
                    opacity: 0.8,
                  },
                }}
              />
            </Link>
            <Stack direction="row" spacing={3}>
              <Link 
                component={RouterLink} 
                to="/about"
                sx={{ 
                  color: '#3A551A', 
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { 
                    textDecoration: 'underline' 
                  } 
                }}
              >
                About
              </Link>
              <Link 
                component={RouterLink} 
                to="/contact"
                sx={{ 
                  color: '#3A551A', 
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { 
                    textDecoration: 'underline' 
                  } 
                }}
              >
                Contact
              </Link>
              <Link 
                component={RouterLink} 
                to="/privacy-policy"
                sx={{ 
                  color: '#3A551A', 
                  textDecoration: 'none',
                  fontWeight: 500,
                  '&:hover': { 
                    textDecoration: 'underline' 
                  } 
                }}
              >
                Privacy Policy
              </Link>
            </Stack>
          </Box>
        </Container>
      </Paper>

      {children}

      <Box 
        component="footer" 
        sx={{ 
          bgcolor: '#F8FAFC',
          borderTop: '1px solid',
          borderColor: 'divider',
          mt: 8,
          py: 4
        }}
      >
        <Container maxWidth="lg">
          <Stack 
            direction={{ xs: 'column', sm: 'row' }} 
            spacing={2} 
            justifyContent="center" 
            alignItems="center"
          >
            <Link 
              component={RouterLink} 
              to="/"
              sx={{ 
                color: '#666', 
                textDecoration: 'none',
                '&:hover': { 
                  color: '#3A551A',
                  textDecoration: 'underline' 
                } 
              }}
            >
              Home
            </Link>
            <Link 
              component={RouterLink} 
              to="/about"
              sx={{ 
                color: '#666', 
                textDecoration: 'none',
                '&:hover': { 
                  color: '#3A551A',
                  textDecoration: 'underline' 
                } 
              }}
            >
              About Us
            </Link>
            <Link 
              component={RouterLink} 
              to="/contact"
              sx={{ 
                color: '#666', 
                textDecoration: 'none',
                '&:hover': { 
                  color: '#3A551A',
                  textDecoration: 'underline' 
                } 
              }}
            >
              Contact
            </Link>
            <Link 
              component={RouterLink} 
              to="/privacy-policy"
              sx={{ 
                color: '#666', 
                textDecoration: 'none',
                '&:hover': { 
                  color: '#3A551A',
                  textDecoration: 'underline' 
                } 
              }}
            >
              Privacy Policy
            </Link>
            <Link 
              component={RouterLink} 
              to="/terms-of-service"
              sx={{ 
                color: '#666', 
                textDecoration: 'none',
                '&:hover': { 
                  color: '#3A551A',
                  textDecoration: 'underline' 
                } 
              }}
            >
              Terms of Service
            </Link>
          </Stack>
        </Container>
      </Box>
    </Box>
  );
} 